// === HOMEPAGE FIX (April 2, 2026) ===
// Fixes: trust bar removal, nav sticky, fake brands, stats consistency
(function(){
  // Only run on homepage
  if(window.location.pathname !== '/' && window.location.pathname !== '') return;
  
  // 1. Remove trust bar (pushed nav down)
  var trustBar = document.querySelector('.mk-trust-bar');
  if(trustBar) trustBar.remove();
  
  // 2. Remove authority section (blue-themed, had fake brands)
  var authority = document.querySelector('.mk-authority');
  if(authority) authority.remove();
  
  // 3. Make nav sticky at top
  var nav = document.querySelector('.mk-nav');
  if(nav) {
    nav.style.position = 'sticky';
    nav.style.top = '0';
    nav.style.zIndex = '9999';
    nav.style.background = '#0d1117';
  }
  
  // 4. Remove fake brand names from any brands grid
  var fakeBrands = ['Dr. Squatch', 'Liquid IV', 'Native', 'Orgain', 'Simple Modern', 'Owala', 'KOS', 'Ancient Nutrition', 'Kitsch', 'Hero Cosmetics', 'Earth Breeze', "Beekeeper's Naturals", 'Groove Life', 'LifeStraw'];
  document.querySelectorAll('.mk-brand, .mk-brands-grid span').forEach(function(el) {
    if(fakeBrands.indexOf(el.textContent.trim()) !== -1) {
      el.remove();
    }
  });
  
  // 5. Fix stats inconsistency - change "10+" to "15+"
  document.querySelectorAll('.mk-stat-num').forEach(function(el) {
    if(el.textContent.trim() === '10+') {
      el.textContent = '15+';
    }
  });
  document.querySelectorAll('.mk-stat-label').forEach(function(el) {
    if(el.textContent.trim() === 'Years Experience') {
      el.textContent = 'Years Deep';
    }
  });
  
  // 6. Fix family section badge - change "SINCE 2015" or "Since 2014" to "SINCE 2010"
  document.querySelectorAll('div, span').forEach(function(el) {
    var t = el.textContent.trim();
    if(t === 'SINCE 2015' || t === 'SINCE 2014' || t === 'Since 2014') {
      el.textContent = 'SINCE 2010';
    }
  });

  // 7. Fix "Does This Sound Familiar?" cards - add premium border-top
  document.querySelectorAll('section').forEach(function(sec) {
    var h2 = sec.querySelector('h2');
    if(h2 && h2.textContent.indexOf('Sound Familiar') !== -1) {
      sec.querySelectorAll('div[style*="border-radius:16px"]').forEach(function(card) {
        if(card.style.background === 'rgb(255, 255, 255)' || card.style.backgroundColor === '#fff' || card.style.background === '#fff') {
          card.style.borderTop = '3px solid #fe5b27';
        }
      });
    }
  });

  // 8. Fix color consistency - remove blue accents
  var style = document.createElement('style');
  style.textContent = '.mk-stat-num { color: #fe5b27 !important; } .mk-cat { color: #fe5b27 !important; background: rgba(254,91,39,0.1) !important; } .mk-cta-btn { background: linear-gradient(135deg, #fe5b27 0%, #ff7849 100%) !important; }';
  document.head.appendChild(style);
  
  // 9. Fix trust bar text in case it has "Since 2014"
  document.querySelectorAll('.mk-trust-text').forEach(function(el) {
    if(el.textContent.indexOf('Since 2014') !== -1) {
      el.textContent = 'Since 2010';
    }
  });
})();


// === NAV HOVER DELAY FIX (April 8, 2026) ===
// Prevents nav dropdowns from closing too fast
(function(){
  var closeTimers = {};
  
  document.querySelectorAll('header details.mega-menu, header details.header__menu-item').forEach(function(details, i) {
    var summary = details.querySelector('summary');
    if (!summary) return;
    
    // On mouse enter the details area, clear any close timer
    details.addEventListener('mouseenter', function() {
      if (closeTimers[i]) {
        clearTimeout(closeTimers[i]);
        closeTimers[i] = null;
      }
    });
    
    // On mouse leave, wait 400ms before closing
    details.addEventListener('mouseleave', function() {
      closeTimers[i] = setTimeout(function() {
        details.removeAttribute('open');
      }, 400);
    });
  });
})();
